export const formatoFechaExportacion = (time) => {


    let date = new Date(time)


    let dia = date.getDate();
    let mes = date.getMonth();
    let year = date.getFullYear();

    let mesPros = parseInt(mes)
    // let hora = date.getHours() + ":" + date.getMinutes();

    let texto = dia + "/" + (mesPros + 1) + "/" + year

    return texto

}